<style media="screen">

    .avatar-uploader .el-upload {
        border: 1px dashed #d9d9d9;
        border-radius: 6px;
        cursor: pointer;
        position: relative;
        overflow: hidden;
    }

    .avatar-uploader .el-upload:hover {
        border-color: #20a0ff;
    }

    .avatar-uploader-icon {
        padding-top: 71px;
        font-size: 28px;
        color: #8c939d;
        width: 178px;
        height: 178px;
        line-height: 178px;
        text-align: center;
    }

    .avatar {
        width: 178px;
        height: 178px;
        display: block;
    }

    input[type=file] {
        display: none;
    }

</style>

<template>

    <el-row>
        <el-form :model="bannerForm" :rules="rules" addAction="businessNews/addNews.action" editAction="businessNews/editNews.action"
                 label-width="100px" ref="bannerForm" selectAction="businessNews/getNews.action" v-form>
            <el-col :span="18" class="basic-margin">

                  <el-form-item label="选择广告位" label-position="left" prop="target">
                      <el-form-item>
                          <el-select v-model="bannerForm.target" >
                              <el-option :value="1" label="首页banner(750*200px)"></el-option>
                              <el-option :value="2" label="首页弹窗(750*1000px)"></el-option>
                              <el-option :value="3" label="详情弹窗(750*1000px)"></el-option>
                              <el-option :value="4" label="推广通banner(750*200px)"></el-option>
                              <el-option :value="5" label="查行情banner(750*200px)"></el-option>
                          </el-select>
                      </el-form-item>
                </el-form-item>

                <el-form-item label="标题" label-position="left" prop="title">
                    <el-input placeholder="输入简要标题（建议30字以内）" v-model="bannerForm.title">
                    </el-input>
                </el-form-item>

                <el-form-item label="链接" label-position="left" prop="link">
                    <el-input placeholder="请输入链接" v-model="bannerForm.link">
                    </el-input>
                </el-form-item>

                <el-form-item label="小程序Appid" label-position="left" prop="miniAppid">
                    <el-input placeholder="小程序Appid" v-model="bannerForm.miniAppid">
                    </el-input>
                </el-form-item>

                <el-form-item label="小程序Path" label-position="left" prop="miniPath">
                    <el-input placeholder="小程序Path" v-model="bannerForm.miniPath">
                    </el-input>
                </el-form-item>

                <el-form-item label="封面图片" label-position="top" prop="coverImg">
                    <el-upload :action="baseUrl+'upload/uploadPic'" :data="{floder:'localCarBusinessIntranet/businessNews'}" :show-file-list="false"
                               accept="image/*" class="avatar-uploader" v-model="bannerForm.coverImg">
                        <img :src="bannerForm.coverImg.url" class="avatar" v-if="bannerForm.coverImg">
                        <i class="el-icon-plus avatar-uploader-icon" v-else></i>
                    </el-upload>
                </el-form-item>

                <el-form-item class="basic-margin">
                    <el-button type="primary">确定</el-button>
                    <el-button @click="$router.back()">取消</el-button>
                </el-form-item>
            </el-col>
        </el-form>

    </el-row>

</template>

<script>

import BasicPager from '@/mixins/BasicPager'
import Config from '@/framework/configs/Config'

export default {
  name: 'save-business-news',
  extends: BasicPager,
  data: function () {
    return {
      checkAll: false,
      visible: false,
      imageUrl: '',
      baseUrl: Config.baseUrl,
      baseImageUrl: Config.imageUrl,
      targetDbtResult: 1,
      channelOptions: [],
      bannerForm: {
        id: null,
        link: '',
        title: '',
        target: null,
        coverImg: null,
        miniPath: null,
        miniAppid: null

      },
      rules: {
        title: [{
          required: true,
          message: '标题不能为空',
          trigger: 'blur'
        }, {
          min: 1,
          max: 50,
          message: '长度在 1 到 50 个字符',
          trigger: 'blur'
        }],
        target: [{
          required: true,
          message: '请选择广告位类型',
          trigger: 'blur'
        }],
        coverImg: [{
          required: true,
          message: '请上传封面图片',
          trigger: 'change'
        }]
      }
    }
  },
  created: function () {
    // 获取参数
    let params = this.$route.params
    if (params) {
      this.bannerForm.id = params.id
    }
  },
  methods: {

  }
}

</script>
